import React, { useEffect, useState } from "react";
import HeadingBanner from "../components/HeadingBanner";
import RetestTaskClassCard from "../components/RetestTaskClassCard";
import LeftPanel from "../components/LeftPanel";
import AlpacaInfoGesture from "../components/AlpacaInfoGesture";
import ClassFilter from "../components/ClassFilter";
import { useNavigate } from "react-router-dom";
import {
  whoami,
  getClasses,
  getTeachers,
  getSchools,
  getCountryGrades,
} from "../services/APIClient";
import { Container, Row, Col } from "react-bootstrap";
import "../components/AssessmentClassCard.css";
import OrientationPrompt from "../components/OrientationPrompt";

function RetestTaskDashboard() {
  // State variables
  const [schoolid, setSchoolid] = useState(null);
  const [teacherid, setTeacherid] = useState(null);
  const [name, setName] = useState("");
  const [teachers, setTeachers] = useState(null);
  const [studentsResponse, setStudentsResponse] = useState("");
  const [firstname, setFirstname] = useState(null);
  const [speechText, setSpeechText] = useState(null);
  const [classes, setClasses] = useState([]);
  const [rollNumber, setRollNumber] = useState(null);
  const [filteredClasses, setFilteredClasses] = useState([]);
  const [gradeLevelOptions, setGradeLevelOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [teacherRoles, setTeacherRoles] = useState(null);

  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );

  const navigate = useNavigate();

  useEffect(() => {
    whoami().then((response) => {
      setSchoolid(response.data.stakeholder.schoolid);
      setTeacherid(response.data.stakeholder.id);
      setName(response.data.stakeholder.name);
      setTeacherRoles(response.data.stakeholder.additionalRoles)
    });
  }, []);

  useEffect(() => {
    // Fetch teachers, classes, and roll number when school ID changes
    async function fetchSchoolData() {
      try {
        const teachersResponse = await getTeachers(schoolid);
        setTeachers(teachersResponse);

        let classesResponse = await getClasses();


        classesResponse = classesResponse.filter(
          (classItem, index, self) =>
            index === self.findIndex((t) => t.id === classItem.id)
        );


        classesResponse.sort(
          (a, b) => new Date(b.date_created) - new Date(a.date_created)
        );
        setClasses(classesResponse);

        const schoolsResponse = await getSchools();
        const matchingSchool = schoolsResponse.data.find(
          (school) => school.id === schoolid
        );

        if (matchingSchool) {
          const rollNumber = matchingSchool.rollnumber;
          const countryid = matchingSchool.countryid;
          setRollNumber(rollNumber);

          getCountryGrades(countryid)
            .then((gradesResponse) => {
              setGradeLevelOptions([gradesResponse]);
            })
            .catch((error) => {
              console.error("Error fetching country grades:", error);
            });
        }
      } catch (error) {
        console.error("Error fetching school data:", error);
      }
    }

    if (schoolid) {
      fetchSchoolData().finally(() => {
        setLoading(false);
      });
    }
  }, [schoolid]);

  useEffect(() => {
    // Split the name into first name when name changes
    if (name) {
      const nameArray = name.split(" ");
      setFirstname(nameArray[0]);
    }
  }, [name, schoolid]);

  useEffect(() => {
    setSpeechText(
      `Whoa slow down there ${firstname}. We need to create a class first. Click into "Admin" on the Left to get this started`
    );
  }, [firstname]);

  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);

  // useEffect(() => {
  //   window.HubSpotConversations?.widget?.refresh();
  // }, []);

  return (
    <div>
      <Container fluid className="vh-100">
        <HeadingBanner
          name={`${name}'s Retest Task`}
          isLoggedIn={true}
          cloud={true}
          teacherid={teacherid}
        />

        <Row className="h-100">
          <LeftPanel />
          <Col sm={{ span: 10, offset: 2 }} className="blue-background">
            {loading ? (
              <div className="spinner-container">
                <div className="big-ball-spinner"></div>
              </div>
            ) : (
              <>
                <Row className="row-position">
                  <Col xs={8}>
                    <ClassFilter
                      classes={classes}
                      setFilteredClasses={setFilteredClasses}
                      gradeLevelOptions={gradeLevelOptions}
                      teacherRoles={teacherRoles}
                    />
                  </Col>
                  <Col xs={4} className="text-end">
                    <button
                      className="blue-button"
                      onClick={() => navigate("/assessmentsdashboard")}
                    >
                      Assign Screener
                    </button>
                  </Col>
                </Row>
                <Row className="row-position-assessment">
                  {classes.length === 0 ? (
                    <>
                      <Col className="col-2"></Col>
                      <Col className="alpaca-message-positioner">
                        <AlpacaInfoGesture speechText={speechText} />
                      </Col>
                    </>
                  ) : (
                    filteredClasses.map((item, index) => (
                      <RetestTaskClassCard
                        key={`${item.id}-${index}`}
                        teachers={teachers}
                        classDetails={item}
                        rollNumber={rollNumber}
                        gradeLevelOptions={gradeLevelOptions}
                        schoolid={schoolid}
                        teacherid={teacherid}
                      />
                    ))
                  )}
                </Row>
              </>
            )}
          </Col>
        </Row>
      </Container>
      {isPortrait && <OrientationPrompt />}
    </div>
  );
}

export default RetestTaskDashboard;
